import type { ReactNode } from 'react';

import { cn } from './cn';

interface Props {
  label: string;
  htmlFor?: string | undefined;
  hint?: string | undefined;
  error?: string | undefined;
  required?: boolean | undefined;
  rightSlot?: ReactNode;
  children: ReactNode;
  className?: string | undefined;
}

export function Field({
  label,
  htmlFor,
  hint,
  error,
  required,
  rightSlot,
  children,
  className,
}: Props): JSX.Element {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div className="flex items-center justify-between">
        <label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
          {label}
          {required ? <span className="ms-0.5 text-destructive">*</span> : null}
        </label>
        {rightSlot}
      </div>
      {children}
      {error ? (
        <p className="text-xs text-destructive" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
}

interface BannerProps {
  children: ReactNode;
  variant?: 'error' | 'info' | 'success';
}

export function FormBanner({ children, variant = 'error' }: BannerProps): JSX.Element {
  const styles =
    variant === 'error'
      ? 'border-destructive/40 bg-destructive/5 text-destructive'
      : variant === 'success'
        ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
        : 'border-border bg-muted text-muted-foreground';
  return (
    <div role="alert" className={cn('rounded-md border px-3 py-2 text-sm', styles)}>
      {children}
    </div>
  );
}
